import styled from 'styled-components'
import { Typography } from 'src/components'
import { motion } from 'framer-motion'

export const TypographyTitle = styled(motion(Typography))`
    font-family: inherit;
    font-style: normal;
    line-height: 46px;
    text-align: center;
    color: transparent;
    background: ${({ theme }) => theme.colors.lineaGradiant};
    -webkit-background-clip: text;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        line-height: 28px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 52px;
    }
`
export const TypographyContent = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    line-height: 18px;
    text-align: center;
    margin-top: 30px;
    color: ${({ theme }) => theme.colors.white};
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        line-height: 25px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 28px;
    }
`
export const LineHeight24 = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    text-align: center;
    color: ${({ theme }) => theme.colors.dark};
    line-height: 23px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        line-height: 22px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 24px;
    }
`
export const LineHeight24Position = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    text-align: start;
    color: ${({ theme }) => theme.colors.dark};
    line-height: 23px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        line-height: 22px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 24px;
    }
`
export const LineHeight25 = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    color: ${({ theme }) => theme.colors.white};
    line-height: 23px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        line-height: 22px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 24px;
    }
`
export const LineHeight15 = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    color: ${({ theme }) => theme.colors.dark};
    line-height: 15px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        line-height: 15px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 150%;
    }
`
export const LineHeight15White = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    color: ${({ theme }) => theme.colors.white};
    line-height: 15px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        line-height: 15px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 150%;
    }
`
